(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwellness-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dw-language-select]').forEach((select) => {
    if (select.dataset.dwBound) return;
    select.dataset.dwBound = 'true';
    select.addEventListener('change', () => select.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwellness-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dw-language-select]').forEach((select) => {
    if (select.dataset.dwBound) return;
    select.dataset.dwBound = 'true';
    select.addEventListener('change', () => select.form.submit());
  });

  // 实时更新购物车数字
  document.addEventListener('cart-lines-update', function(e) {
    const el = document.getElementById('dw-cart-count');
    if (!el) return;
    if (e.detail && e.detail.cart) {
      el.textContent = e.detail.cart.totalQuantity ?? 0;
    } else {
      fetch('/cart.js').then(r => r.json()).then(function(cart) {
        el.textContent = cart.item_count;
      });
    }
  });

  // 备用：监听 form submit
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      setTimeout(function() {
        fetch('/cart.js').then(r => r.json()).then(function(cart) {
          const el = document.getElementById('dw-cart-count');
          if (el) el.textContent = cart.item_count;
        });
      }, 1200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwellness-wholesale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwellness-tiered-price')) {
    customElements.define(
      'dwellness-tiered-price',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[name="quantity"]');
          this.output = this.querySelector('output');
          this.unitPrice = this.querySelector('[data-unit-price]');
          this.totalPrice = this.querySelector('[data-total-price]');
          this.button = this.querySelector('button[type="submit"]');
          this.available = this.dataset.available === 'true';
          this.input.addEventListener('input', () => this.update());
        }

        update() {
          const quantity = Number(this.input.value);
          const valid = Number.isInteger(quantity) && quantity >= 1;
          if (!valid) {
            this.output.hidden = true;
            this.button.disabled = true;
            return;
          }

          let unitPrice = 49.99;
          if (quantity >= 100) unitPrice = 15;
          else if (quantity >= 50) unitPrice = 16.5;
          else if (quantity >= 10) unitPrice = 18;

          const currency = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: 'USD'
          });
          this.unitPrice.textContent = `${currency.format(unitPrice)} ${this.dataset.unitLabel}`;
          this.totalPrice.textContent = `${this.dataset.totalLabel}: ${currency.format(unitPrice * quantity)}`;
          this.output.hidden = false;
          this.button.disabled = !this.available;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
